var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430 430",
    style: {
      enableBackground: "new 0 0 430 430"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.6124,
    y1: 91.6122,
    x2: 338.3876,
    y2: 338.3875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cb5eee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4be1ec"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.4,91.6c-33-33-76.8-51.1-123.4-51.1S124.6,58.7,91.6,91.6c-68,68-68,178.7,0,246.8 c33,33,76.8,51.1,123.4,51.1s90.4-18.2,123.4-51.1C406.4,270.4,406.4,159.6,338.4,91.6z M329.9,329.9 c-30.7,30.7-71.5,47.6-114.9,47.6s-84.2-16.9-114.9-47.6c-63.4-63.4-63.4-166.4,0-229.8c30.7-30.7,71.5-47.6,114.9-47.6 s84.2,16.9,114.9,47.6C393.3,163.5,393.3,266.5,329.9,329.9z M279.5,150.5c2.3,2.3,2.3,6.1,0,8.5l-60.2,60.2 c-1.2,1.2-2.7,1.8-4.2,1.8s-3.1-0.6-4.2-1.8c-1.6-1.6-2.1-3.8-1.5-5.8c-0.2-0.5-0.2-1.1-0.2-1.7V96c0-3.3,2.7-6,6-6s6,2.7,6,6v104.5 l50-50C273.3,148.2,277.1,148.2,279.5,150.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTime);
export default __webpack_public_path__ + "static/media/clock-time.d0d4c5da97e29247d3217b516a6959c7.svg";
export { ForwardRef as ReactComponent };